import { CSSProperties } from "react";

export default {
  appContainer: (alertsExist: boolean): CSSProperties => ({
    display: "flex",
    flexDirection: "row",
    flex: 1,
    minHeight: 0,
    width: "100%",
    pointerEvents: alertsExist ? "none" : "auto",
  }),
  flex: {
    display: "flex",
  },
  appWrapper: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    minHeight: "100%",
    width: "100%",
    background:
      "radial-gradient(circle at top left, rgba(64, 109, 255, 0.12), transparent 24%), radial-gradient(circle at top right, rgba(40, 194, 160, 0.10), transparent 20%), linear-gradient(180deg, #f6f8fc 0%, #edf3fb 100%)",
  } as CSSProperties,
  convosWrapper: {
    height: "100%",
    width: 320,
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    maxWidth: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.94)",
    borderRight: "1px solid #DDE5F0",
    boxShadow: "0 24px 60px rgba(71, 95, 135, 0.08)",
  } as CSSProperties,
  messagesWrapper: {
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    backgroundColor: "rgba(248, 251, 255, 0.68)",
  } as CSSProperties,
  appHeader: {
    display: "flex",
    justifyContent: "space-between",
    background:
      "linear-gradient(135deg, #10213D 0%, #16345A 52%, #1E5CA8 100%)",
    padding: "20px 25px",
    flexWrap: "wrap",
    borderBottom: "1px solid rgba(214, 227, 244, 0.18)",
    boxShadow: "0 20px 48px rgba(16, 33, 61, 0.28)",
  } as CSSProperties,
  appLogoWrapper: {
    width: "40px",
    height: "40px",
    borderRadius: "12px",
    border: "1px solid rgba(255, 255, 255, 0.22)",
    backgroundColor: "rgba(255, 255, 255, 0.10)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 14px 24px rgba(7, 21, 40, 0.22)",
  } as CSSProperties,
  appLogoTitle: {
    fontSize: "15px",
    fontWeight: 700,
    textAlign: "left",
    color: "#FFFFFF",
    lineHeight: "22px",
    paddingLeft: "16px",
    minWidth: 0,
  } as CSSProperties,
  appLogoSubTitle: {
    fontSize: "11px",
    fontWeight: 700,
    textAlign: "left",
    color: "#C7D8F5",
    lineHeight: "18px",
    textTransform: "uppercase",
    letterSpacing: "0.12em",
  } as CSSProperties,
  userTile: {
    display: "flex",
    alignItems: "center",
    minWidth: 0,
  },
  userName: {
    color: "#FFFFFF",
    fontSize: "12px",
    fontWeight: 700,
    lineHeight: "20px",
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  } as CSSProperties,
  userStatus: {
    fontSize: "12px",
    display: "flex",
    flexDirection: "row",
    lineHeight: "20px",
    fontWeight: "400",
    alignItems: "center",
    justifyContent: "center",
  } as CSSProperties,
  paginationSpinner: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 16,
  } as CSSProperties,
  app: {
    flex: 1,
    minHeight: "100vh",
    width: "100%",
  } as CSSProperties,
  buttonWrapper: {
    flexDirection: "row",
    paddingRight: "16px",
  } as CSSProperties,
  convosWrapperBox: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  } as CSSProperties,
  convoList: {
    overflowY: "auto",
    flex: 1,
    minHeight: 0,
  } as CSSProperties,
  collapseButtonBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    width: "100%",
    paddingTop: "12px",
    paddingBottom: "20px",
    paddingRight: "16px",
    paddingLeft: "16px",
    marginTop: "auto",
    borderTop: "1px solid #DCE5EF",
    backgroundColor: "rgba(249, 251, 255, 0.92)",
  } as CSSProperties,
  newConvoButton: {
    padding: "14px 16px",
    width: "100%",
    borderBottom: "1px solid #DCE5EF",
    backgroundColor: "rgba(249, 251, 255, 0.9)",
  } as CSSProperties,
  addParticipantsButton: {
    padding: "14px 16px",
    width: "100%",
  } as CSSProperties,
  loginContainer: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    position: "relative",
    overflowX: "hidden",
    overflowY: "auto",
    background:
      "radial-gradient(circle at top left, rgba(70, 108, 255, 0.28), transparent 28%), radial-gradient(circle at bottom right, rgba(34, 194, 166, 0.18), transparent 24%), linear-gradient(180deg, #0F1D35 0%, #132746 52%, #183764 100%)",
  } as CSSProperties,
  logo: {
    width: "42px",
  } as CSSProperties,
  loginEyebrow: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "7px 12px",
    borderRadius: "999px",
    border: "1px solid rgba(205, 224, 255, 0.22)",
    backgroundColor: "rgba(232, 241, 255, 0.10)",
    color: "#D9E7FF",
    fontSize: "11px",
    fontWeight: 700,
    letterSpacing: "0.16em",
    textTransform: "uppercase",
    marginBottom: "16px",
  } as CSSProperties,
  loginLogoShell: {
    width: "92px",
    height: "92px",
    padding: "10px",
    borderRadius: "28px",
    border: "1px solid rgba(255, 255, 255, 0.16)",
    backgroundColor: "rgba(255, 255, 255, 0.10)",
    boxShadow: "0 24px 60px rgba(5, 12, 24, 0.34)",
    marginBottom: "20px",
  } as CSSProperties,
  loginTitle: {
    paddingTop: "2px",
    color: "#FFFFFF",
    fontSize: "34px",
    lineHeight: "40px",
    fontWeight: 700,
    textAlign: "center",
    maxWidth: "720px",
  } as CSSProperties,
  loginTitleSubline: {
    marginTop: "8px",
    color: "#D9E7FF",
    fontSize: "18px",
    lineHeight: "26px",
    fontWeight: 600,
    textAlign: "center",
    maxWidth: "720px",
  } as CSSProperties,
  subTitle: {
    color: "#C5D5ED",
    fontSize: "15px",
    lineHeight: "26px",
    paddingTop: "8px",
    paddingBottom: "22px",
    textAlign: "center",
    maxWidth: "700px",
  } as CSSProperties,
  loginContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    position: "relative",
    width: "100%",
    minHeight: "100vh",
    padding: "48px 16px 64px",
    boxSizing: "border-box",
    zIndex: 3,
  } as CSSProperties,
  loginFeatureGrid: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "10px",
    width: "100%",
    marginTop: "12px",
  } as CSSProperties,
  loginFeatureCard: {
    padding: "14px 16px",
    borderRadius: "18px",
    border: "1px solid rgba(220, 230, 242, 0.48)",
    backgroundColor: "rgba(255, 255, 255, 0.10)",
    boxShadow:
      "0 18px 34px rgba(8, 20, 38, 0.14), inset 0 1px 0 rgba(255,255,255,0.06)",
    color: "#E4EEFB",
    textAlign: "left",
  } as CSSProperties,
  loginModuleStack: {
    position: "relative",
    width: "min(100%, 460px)",
    paddingTop: "18px",
  } as CSSProperties,
  loginModuleConnector: {
    position: "absolute",
    top: 0,
    left: "50%",
    transform: "translateX(-50%)",
    width: "2px",
    height: "22px",
    borderRadius: "999px",
    background:
      "linear-gradient(180deg, rgba(151, 180, 255, 0.10) 0%, rgba(151, 180, 255, 0.58) 100%)",
    boxShadow: "0 0 0 4px rgba(151, 180, 255, 0.08)",
  } as CSSProperties,
  loginModuleDivider: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "10px",
  } as CSSProperties,
  loginModuleDividerPill: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 12px",
    borderRadius: "999px",
    border: "1px solid rgba(220, 230, 242, 0.26)",
    backgroundColor: "rgba(255, 255, 255, 0.08)",
    color: "#D7E5FB",
    fontSize: "10px",
    fontWeight: 700,
    letterSpacing: "0.16em",
    textTransform: "uppercase",
    boxShadow: "0 12px 24px rgba(8, 20, 38, 0.12)",
  } as CSSProperties,
  loginForm: {
    backgroundColor: "rgba(255, 255, 255, 0.96)",
    borderRadius: "28px",
    width: "100%",
    border: "1px solid rgba(220, 230, 242, 0.92)",
    boxShadow: "0 32px 70px rgba(10, 22, 40, 0.30)",
    backdropFilter: "blur(16px)",
  } as CSSProperties,
  userInput: {
    paddingTop: "30px",
    width: "auto",
    marginLeft: "28px",
    marginRight: "28px",
  } as CSSProperties,
  passwordInput: {
    paddingTop: "18px",
    width: "auto",
    marginLeft: "28px",
    marginRight: "28px",
  } as CSSProperties,
  loginButton: {
    paddingTop: "34px",
    paddingBottom: "12px",
    marginLeft: "28px",
    marginRight: "28px",
  } as CSSProperties,
  loginSecondaryButton: {
    paddingBottom: "14px",
    marginLeft: "28px",
    marginRight: "28px",
  } as CSSProperties,
  installHint: {
    color: "#506279",
    fontSize: "12px",
    lineHeight: "20px",
    textAlign: "center",
    paddingBottom: "28px",
    marginLeft: "28px",
    marginRight: "28px",
  } as CSSProperties,
  loginBackground: {
    position: "absolute",
    inset: 0,
    width: "100%",
    pointerEvents: "none",
    overflow: "hidden",
  } as CSSProperties,
  modalInputLabel: {
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "20px",
  } as CSSProperties,
  settingsWrapper: {
    zIndex: 1,
    paddingTop: "22px",
  } as CSSProperties,
  optionWrapper: {
    width: "232px",
  } as CSSProperties,
  collapsedList: {
    width: "70px",
  } as CSSProperties,
};
